import React from 'react'
import Popup from '../../../../../common/Popup/Popup';
import AppTable from '../../../../../common/AppTable/AppTable';
import { TableActionGroup } from '../../../../../common/Buttons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

const PreviewPopupTable = ({ suggestionRule, hidePopup }) => {
  // Format type_names array for display
  const formatTypeNames = (typeNames) => {
    if (!typeNames || !Array.isArray(typeNames) || typeNames.length === 0) {
      return "-";
    }
    return typeNames.join(", ");
  };

  const columnsData = [
    { headName: "Suggestion", field: "rule_name" },
    { headName: "Applicable Types", field: "type_names" },
    { headName: "Criteria", field: "criteria" },
    { headName: "Criteria Format", field: "criteria_format_text" },
    { headName: "Matches", field: "matches", textCenter: true },
    { headName: "Action", field: "action", textCenter: true },
  ];

  return (
    <Popup
      title="Suggestion Rule"
      closeModal={hidePopup}
    >
      <AppTable
        columnsData={columnsData}
        showSearchInput={false}
        paginate={false}
        extrapadding="10px"
        usingInPopup={true}
      >
        {suggestionRule && (
          <tr>
            <td
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                padding: "6px",
              }}
            >
              {suggestionRule.rule_name || "-"}
            </td>
            <td
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                padding: "6px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "4px",
                  alignItems: "center",
                }}
              >
                {suggestionRule.type_names.map((type, index) => (<span
                  key={type}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "4px",
                    padding: "4px 8px",
                    backgroundColor: "#E9ECEF",
                    borderRadius: "4px",
                    fontSize: "12px",
                    color: "#333",
                  }}
                >
                  {type}
                </span>
                ))}
              </div>
            </td>
            <td
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                padding: "6px",
              }}
            >
              {suggestionRule.criteria || "-"}
            </td>
            <td
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                padding: "6px",
              }}
            >
              {suggestionRule.criteria_format_text || "-"}
            </td>
            <td style={{ textAlign: "center", padding: "6px" }}>
              <button
                style={{
                  backgroundColor: "white",
                  color: "#0D6EFD",
                  border: "1px solid #0D6EFD",
                  padding: "4px 12px",
                  borderRadius: "4px",
                  fontSize: "12px",
                }}
                disabled={false}
              >
                <span>{parseInt(suggestionRule.match_count) || 0} matches</span>
                <FontAwesomeIcon
                  icon={faArrowRight}
                  style={{ marginLeft: "8px", fontSize: "14px" }}
                />
              </button>
            </td>
            <td style={{ textAlign: "center", padding: "6px" }}>
              <TableActionGroup
                mode="view"
                showEdit={true}
                showDelete={true}
                disableEdit={true}
                disableDelete={true}
                onEdit={() => { }}
                onDelete={() => { }}
              />
            </td>
          </tr>
        )}
      </AppTable>
    </Popup>
  );
};

export default PreviewPopupTable;

